import { render, staticRenderFns } from "./PlatformSection.vue?vue&type=template&id=04006e2c&"
import script from "./PlatformSection.vue?vue&type=script&lang=js&"
export * from "./PlatformSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports